<p-editor
  [ngModel]="valor"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onValorEditado($event)"
  [readonly]="somenteLeitura"
  [styleClass]="somenteLeitura ? 'editor-desabilitado' : ''"
  [placeholder]="placeholder"
  [style]="{ height: altura }"
>
  <ng-template pTemplate="header">
    <span class="ql-formats">
      <select class="ql-font"></select>
      <select class="ql-size"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-bold" type="button" aria-label="Negrito"></button>
      <button class="ql-italic" type="button" aria-label="Itálico"></button>
      <button class="ql-underline" type="button" aria-label="Sublinhado"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" type="button" aria-label="Lista numerada"></button>
      <button class="ql-list" value="bullet" type="button" aria-label="Lista com marcadores"></button>
      <select class="ql-align"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-link" type="button" aria-label="Inserir link"></button>
      <button class="ql-clean" type="button" aria-label="Remover formatação"></button>
    </span>
  </ng-template>
</p-editor>
